document.addEventListener('DOMContentLoaded', function() {
  const tabNames = document.querySelectorAll('.bodyeft-tabname');
  const contents = document.querySelectorAll('.bodyeft-content');

  tabNames.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabNames.forEach(function(otherTab) {
        otherTab.classList.remove('active');
      });
      this.classList.add('active');

      const tabId = this.getAttribute('data-tab');

      contents.forEach(function(content) {
        content.classList.remove('active');
      });
      const activeContent = document.querySelector(`.bodyeft-content#${tabId}`);
      if (activeContent) {
        activeContent.classList.add('active');
      }
    });
  });
});